import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';

/**
 * Mock API toggle.
 *
 * Written as a direct comparison against `import.meta.env` rather than a helper
 * call so Vite can fold it to a literal at build time and Rollup can drop the
 * whole MSW chunk (~300 kB) from a production bundle. Build with
 * VITE_ENABLE_MOCKS=true to keep it, e.g. for a backend-free demo image.
 */
const USE_MOCKS = import.meta.env.DEV || import.meta.env.VITE_ENABLE_MOCKS === 'true';

async function bootstrap(): Promise<void> {
  if (USE_MOCKS) {
    const { startMockServer } = await import('./mocks/browser');
    await startMockServer();
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('Missing #root element.');

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
